export const DEPARTMENTS = [
    { code: '05', name: 'Antioquia', capital: 'Medellín' },
    { code: '08', name: 'Atlántico', capital: 'Barranquilla' },
    { code: '11', name: 'Bogotá, D.C.', capital: 'Bogotá, D.C.' },
    { code: '13', name: 'Bolívar', capital: 'Cartagena de Indias' },
    { code: '15', name: 'Boyacá', capital: 'Tunja' },
    { code: '17', name: 'Caldas', capital: 'Manizales' },
    { code: '18', name: 'Caquetá', capital: 'Florencia' },
    { code: '19', name: 'Cauca', capital: 'Popayán' },
    { code: '20', name: 'Cesar', capital: 'Valledupar' },
    { code: '23', name: 'Córdoba', capital: 'Montería' },
    { code: '25', name: 'Cundinamarca', capital: 'Bogotá, D.C.' },
    { code: '27', name: 'Chocó', capital: 'Quibdó' },
    { code: '41', name: 'Huila', capital: 'Neiva' },
    { code: '44', name: 'La Guajira', capital: 'Riohacha' },
    { code: '47', name: 'Magdalena', capital: 'Santa Marta' },
    { code: '50', name: 'Meta', capital: 'Villavicencio' },
    { code: '52', name: 'Nariño', capital: 'Pasto' },
    { code: '54', name: 'Norte de Santander', capital: 'Cúcuta' },
    { code: '63', name: 'Quindío', capital: 'Armenia' },
    { code: '66', name: 'Risaralda', capital: 'Pereira' },
    { code: '68', name: 'Santander', capital: 'Bucaramanga' },
    { code: '70', name: 'Sucre', capital: 'Sincelejo' },
    { code: '73', name: 'Tolima', capital: 'Ibagué' },
    { code: '76', name: 'Valle del Cauca', capital: 'Cali' },
    { code: '81', name: 'Arauca', capital: 'Arauca' },
    { code: '85', name: 'Casanare', capital: 'Yopal' },
    { code: '86', name: 'Putumayo', capital: 'Mocoa' },
    { code: '88', name: 'Archipiélago de San Andrés, Providencia y Santa Catalina', capital: 'San Andrés' },
    { code: '91', name: 'Amazonas', capital: 'Leticia' },
    { code: '94', name: 'Guainía', capital: 'Inírida' },
    { code: '95', name: 'Guaviare', capital: 'San José del Guaviare' },
    { code: '97', name: 'Vaupés', capital: 'Mitú' },
    { code: '99', name: 'Vichada', capital: 'Puerto Carreño' },
];
export const departmentByCode = (code) => DEPARTMENTS.find((d) => d.code === code);
/** Un código de municipio DIVIPOLA tiene 5 dígitos; los dos primeros son el departamento. */
export function departmentOfMunicipality(municipalityCode) {
    return /^\d{5}$/.test(municipalityCode) ? departmentByCode(municipalityCode.slice(0, 2)) : undefined;
}
//# sourceMappingURL=divipola.js.map